export default __webpack_public_path__ + "static/media/wickIcon.93a63c39.gif";